import { LocalStorageKeys } from "../enums";

class LocalStorageService {
  getLocalStorageData<T>(key: LocalStorageKeys): T | null {
    try {
      const data = localStorage.getItem(key);
      return data ? (JSON.parse(data) as T) : null;
    } catch (error) {
      throw new Error("Error getting local storage data");
    }
  }

  setLocalStorageData<T>(key: LocalStorageKeys, data: T): void {
    try {
      localStorage.setItem(key, JSON.stringify(data));
    } catch (error) {
      throw new Error("Error setting local storage data");
    }
  }

  resetLocalStorageData(key: LocalStorageKeys): void {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      throw new Error("Error resetting local storage data");
    }
  }

  clearLocalStorageData(): void {
    try {
      localStorage.clear();
    } catch (error) {
      throw new Error("Error clearing local storage data");
    }
  }
}

export { LocalStorageService };
